import { render, staticRenderFns } from "./standard_edit.vue?vue&type=template&id=450a5496&scoped=true&"
import script from "./standard_edit.vue?vue&type=script&lang=js&"
export * from "./standard_edit.vue?vue&type=script&lang=js&"
import style0 from "./standard_edit.vue?vue&type=style&index=0&id=450a5496&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450a5496",
  null
  
)

export default component.exports